<script setup lang="ts">
// One payment-rail mark on a white chip (brand colours need a light tile):
// the simple-icons glyph for a known slug, else the rail's own `icon` URL,
// else its name. Used by the storefront PaymentMarks row and the admin.
import { computed } from 'vue';
import { paymentIcon } from '../utils/brand-icons';
import BrandMark from './BrandMark.vue';

const props = defineProps<{ slug: string; name: string; icon?: string }>();
const glyph = computed(() => paymentIcon(props.slug));
</script>

<template>
  <span class="inline-grid h-7 min-w-11 place-items-center rounded bg-white px-1.5" :title="name">
    <BrandMark v-if="glyph" :icon="glyph" color="brand" class="h-3.5 w-8" />
    <img v-else-if="icon" :src="icon" :alt="name" class="h-3.5 w-8 object-contain" />
    <span v-else class="whitespace-nowrap text-[10px] font-semibold leading-none text-[#1d1b1a]">{{ name }}</span>
  </span>
</template>
